export default __webpack_public_path__ + "static/media/home_polygon.1c031bdb.svg";